import React from 'react';
import AppStore from 'AppStore';

import * as Strings from '../../utils/strings';
import CustomText from '../../common/components/CustomText';
import CustomButton from '../../common/components/CustomButton';
import { getCreditApp } from './PortfolioActions';

import './Portfolio.css';

export default class CreditApp extends React.Component {
    constructor() {
        super();
        this.state = {
            portfolio: null,
            creditApp: null
            // creditApp: {
            //     description: 'fhgkhjkhgu',
            //     creditDecision: 'Pending - Sent for Approval',
            //     creditAppNumber: 'BK-05818',
            //     creditAppId: 'a090x000001OGfzAAG',
            //     createdDate: '2018-02-16',
            //     applicationStatus: 'UNK',
            //     applicationAmount: 1000
            // }
        };
    }

    componentWillMount = () => {
        AppStore.on('credit_app_retrieved', this.onCreditRetrieved);
        const cb = () => {
            getCreditApp(this.props.match.params.creditAppId);
        };
        setTimeout(cb, 500);
    };

    componentWillUnmount = () => {
        AppStore.removeListener('credit_app_retrieved', this.onCreditRetrieved);
    };
    onCreditRetrieved = () => {
        const creditApp = AppStore.getAppState().creditApp;

        this.setState({ creditApp: creditApp });
    };

    render() {
        if (!this.state.creditApp) {
            return (
                <div className="hack">
                    <div id="app-container">
                        <center>loading...</center>
                    </div>
                </div>
            );
        }

        const payload = this.state.creditApp;

        return (
            <div className="more hack">
                <div id="app-container">
                    <div id="quotes-container" className="form-container">
                        <div className="select-quote-options">
                            <h2>
                                <center>Credit Application</center>
                            </h2>
                            <br />

                            <div className="row select-term">
                                <CustomText
                                    label="Application#"
                                    textValue={payload.creditAppNumber}
                                    customRef="1"
                                />
                                <CustomText
                                    label="Creation Date"
                                    textValue={payload.createdDate}
                                    customRef="1"
                                />
                                <CustomText
                                    label="Application"
                                    textValue={payload.applicationAmount}
                                    customRef="1"
                                    format="currency"
                                />
                                <CustomText
                                    label="Asset Description"
                                    textValue={payload.description}
                                    customRef="1"
                                />

                                <CustomText
                                    label="Credit Decision"
                                    textValue={payload.creditDecision}
                                    customRef="1"
                                />
                                <CustomText
                                    label="Application Status"
                                    textValue={payload.applicationStatus}
                                    customRef="1"
                                />
                            </div>
                            <br />
                            <br />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/portfolio/CreditApp.jsx